import { FC, useState } from "react";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { getBuyersFilterApi } from "api/common";
import { PackagesNotReleasedFilter } from "api/package";
import { Vessel } from "interface/vessel";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";
import { getVesselFilter } from "api/vessel";
import { NumericTextBox } from "@progress/kendo-react-inputs";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: PackagesNotReleasedFilter) => void;
	filterOptions: PackagesNotReleasedFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	...props
}) => {
	const { t } = useTranslation();

	const [tempRegFilter, setTempRegFilter] = useState<null | number>(null);
	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id,
			vesselName: vessel.id ? vessel.nm : "",
			// vesselLedgerAccountNumber: vessel.res as any,
			vesselRegistrationId: vessel.rn as any,
		});
	};
	const applyRegistrationId = () => {
		const newValue = tempRegFilter;
		const currentValue = filterOptions.registrationId;
		if (newValue === currentValue) return;
		setFilterOptions({
			...filterOptions,
			registrationId: tempRegFilter,
		});
	};
	return (
		<div className="filter-container">
			<div className="filter-items released-package-filter-items">
				<div
					className="released-package-filter-field"
					style={{ width: "200px" }}
				>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fartøy"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						itemRender={VesselRenderItem()}
						serverFilterApi={getVesselFilter}
					/>
				</div>
				<div className="" style={{ width: "200px" }}>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerLedgerAccountNumber: buyer.id,
								buyerName: buyer.displayName,
							})
						}
						data={[]}
						value={{
							id: filterOptions?.buyerLedgerAccountNumber || null,
							name: filterOptions?.buyerName || " ",
						}}
						dataItemKey="id"
						textField="name"
						// placeholder={t("Buyer")}
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
				<div className="" style={{ width: "200px" }}>
					<NumericTextBox
						className="height-inherit "
						label={t("RegistrationId")}
						placeholder=" "
						style={{ width: "100%" }}
						value={Number.isNaN(tempRegFilter) ? null : tempRegFilter}
						onChange={(e) => setTempRegFilter(e.value)}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applyRegistrationId();
						}}
						onBlur={() => applyRegistrationId()}
						spinners={false}
						format=""
					/>
				</div>
			</div>

			<div className="filter-end-btn">
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
